module.exports = __webpack_public_path__ + "static/media/notification.a443ad3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/notification.svg
// module id = 765
// module chunks = 0